import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FantasyGamePanelComponent } from './components/fantasy-game-panel/fantasy-game-panel.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { FantasyPlayerSelectComponent } from './components/fantasy-player-select/fantasy-player-select.component';
import { RouterModule } from '@angular/router';
import { FantasyHistoryListComponent } from './components/fantasy-history-list/fantasy-history-list.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { FantasyHistoryListItemComponent } from './components/fantasy-history-list-item/fantasy-history-list-item.component';
import { FantasyPlayerSelectConfirmComponent } from './components/fantasy-player-select-confirm/fantasy-player-select-confirm.component';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { FantasyLeaderboardComponent } from './components/fantasy-leaderboard/fantasy-leaderboard.component';
import { FantasyGamePanelNextGameComponent } from './components/fantasy-game-panel-next-game/fantasy-game-panel-next-game.component';

import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { CountdownModule } from '@fgb/portal-component-library/src/lib/shared/countdown';
import { FantasyGameRulesComponent } from './components/fantasy-game-rules/fantasy-game-rules.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';
import { LayoutModule } from '../layouts/layout.module';
import { FantasyUpNextV2Component } from './components/fantasy-up-next-v2/fantasy-up-next-v2.component';
import { FantasyGameRulesV2Component } from './components/fantasy-game-rules-v2/fantasy-game-rules-v2.component';
import { FantasyLeaderboardV2Component } from './components/fantasy-leaderboard-v2/fantasy-leaderboard-v2.component';
import { ClubModule } from '../club/club.module';
import { FantasyGameResultsComponent } from './components/fantasy-game-results/fantasy-game-results.component';
import { FantasyGamePlayV2Component } from './components/fantasy-game-play-v2/fantasy-game-play-v2.component';
import { FantasyGamePanelV2Component } from './components/fantasy-game-panel-v2/fantasy-game-panel-v2.component';
import { FantasyPlayerSelectV2Component } from './components/fantasy-player-select-v2/fantasy-player-select-v2.component';

@NgModule({
  declarations: [
    FantasyGamePanelComponent,
    FantasyPlayerSelectComponent,
    FantasyHistoryListComponent,
    FantasyHistoryListItemComponent,
    FantasyPlayerSelectConfirmComponent,
    FantasyLeaderboardComponent,
    FantasyGamePanelNextGameComponent,
    FantasyGameRulesComponent,
    FantasyUpNextV2Component,
    FantasyGameRulesV2Component,
    FantasyLeaderboardV2Component,
    FantasyGameResultsComponent,
    FantasyGamePlayV2Component,
    FantasyGamePanelV2Component,
    FantasyPlayerSelectV2Component,
  ],
  exports: [
    FantasyGamePanelComponent,
    FantasyPlayerSelectComponent,
    FantasyHistoryListComponent,
    FantasyGamePanelNextGameComponent,
    FantasyLeaderboardComponent,
    FantasyGameRulesComponent,
    FantasyUpNextV2Component,
    FantasyLeaderboardV2Component,
    FantasyGameResultsComponent,
    FantasyGamePlayV2Component,
    FantasyGamePanelV2Component,
    FantasyPlayerSelectV2Component,
  ],
  imports: [
    NgbModule,
    RouterModule,
    SharedModule,
    CommonModule,
    CarouselModule,
    CountdownModule,
    InlineSVGModule.forRoot(),
    FGBSharedModule,
    DirectivesModule,
    LayoutModule,
    ClubModule,
  ],
})
export class FantasyModule {}
